// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFanFollowRequestsListBody = {
  cursor?: string | null;
  limit?: number | null;
};

export type typeFanFollowRequestsListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      accountId: string;
      username: string;
      displayName: string;
      photoUrl?: string | null;
      requestedAt: string;
    }[];
    nextCursor?: string | null;
  };
};

export type typeFanFollowRequestsListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRequestsListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRequestsListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFanFollowRequestsListBody = {
  type: "object",
  properties: {
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFanFollowRequestsList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFanFollowRequestsListBody);
  }

  return async function postFanFollowRequestsList(
    payload: typeFanFollowRequestsListBody,
  ): Promise<
    typeFanFollowRequestsListOutput200 | typeFanFollowRequestsListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFanFollowRequestsList" failed before calling the network. #50c295aea019`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#50c295aea019" },
        },
        data: null,
      } as typeFanFollowRequestsListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/fan-follow/requests-list`,
      httpMethod: "POST",
      options,
    })) as
      typeFanFollowRequestsListOutput200 | typeFanFollowRequestsListOutput400;
  };
}
